import Vue from "vue";
import VueI18n from "vue-i18n";
import es from "../../../locales/es/vue";
import pt from "../../../locales/pt/vue";
import en from "../../../locales/en/vue";

Vue.use(VueI18n);

const messages = {
  es,
  pt,
  en
};
const i18n = new VueI18n({
  locale: document.documentElement.lang,
  fallbackLocale: "es",
  messages
});

export default i18n;
